import ShowCustomers from "./ShowCustomers";
import CustomersOptionsSearch from "./customers-options-search";
import CustomersTable from "./customers-table";

export default ShowCustomers;

export { CustomersOptionsSearch, CustomersTable };
